import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import useMap from 'tennders-transactions/hooks/useMap'
import { CurrencyInput, InputLabeledContainer, NumberInput } from 'tennders-common/form/components'
import { withSendOffer } from 'tennders-market/offer/hocs/withSendOffer'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import { isEmpty } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import OfferSentMessage from './OfferSentMessage'

const FirstOfferToTruck = ({
  onChange,
  form,
  step,
  setstep,
  submitting,
  errors,
  savingRoute,
  reset,
  sendBid,
  transaction
}) => {
  const { mapForm } = useMap()
  const { selectedDistance } = useMap()
  const { t } = useTranslation()

  const isRouteOffered = !isEmpty(mapForm?.pickupRoute) && !isEmpty(mapForm?.deliveryRoute)

  return (
    <table className="w-100">
      <tbody>
        <tr>
          <td colSpan="2" className="tennders-offer-panel-table w-100 p-0 pos-rel">
            <div className="w-90 bg-color-white pos-rel p-8">
              <div className="d-flex align-center justify-space pos-rel border-b">
                <div className="w-50">
                  <div className="p-10">
                    <div className="d-flex align-center">
                      <div className="step-no mr-10">1</div>
                      <div className="flex-1">{t('transaction:fillInfoPrompt')}</div>
                    </div>
                  </div>
                </div>
                <div className="w-50 text-right">
                  <div className="p-10">
                    <GHref
                      disabled={!isRouteOffered}
                      onClick={isRouteOffered ? () => setstep(1) : null}
                      className="btn standard-btn small bold confirm-step-btn"
                    >
                      {t('transaction:confirmPickUpDelivery')}
                    </GHref>
                  </div>
                </div>
                {step > 0 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>
              <div className="d-flex justify-space pos-rel border-b">
                <div className="w-100">
                  <div className="p-10">
                    <div className="d-flex">
                      <div className="step-no mr-10">2</div>
                      <div className="flex-1">
                        <p>
                          {t('transaction:confirmSelectedRoute')}
                          <br />
                          {t('transaction:dragBetween')}
                          <br />
                        </p>
                        <p>
                          {t('transaction:selectedDistance')}
                          <br />
                          :
                          {' '}
                          {' '}
                          <strong>
                            <DistanceInKm value={selectedDistance} />
                          </strong>
                        </p>
                        {form?.emptyKm && (
                          <p>
                            {t('transaction:emptyKmDistance')}
                            <br />
                            :
                            {' '}
                            <strong>
                              <DistanceInKm value={form?.emptyKm} />
                            </strong>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="ml-40">
                      <div>
                        <GHref
                          onClick={(step < 1 || !selectedDistance) ? null : () => setstep(2)}
                          disabled={step < 1 || !selectedDistance}
                          className="btn standard-btn small  bold confirm-step-btn-2"
                        >
                          <Trans i18nKey="offer:confirmRoute" />
                        </GHref>
                      </div>
                    </div>
                  </div>
                </div>
                {step > 1 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>
              <div className="d-flex justify-space pos-rel border-b">
                <div>
                  <div className="p-10">
                    <div className="d-flex align-center">
                      <div className="step-no mr-10">3</div>
                      <div className="flex-1">{t('transaction:enterBid')}  </div>
                    </div>
                    <div className="italic ml-40">
                      {transaction?.matchedTruck?.targetPrice
                        ? (
                          <>
                            {t('transaction:preferredPriceIs', { company: transaction?.matchedTruck?.company?.name || t('transaction:theCompany') })}
                            {' '}
                            <GCurrency
                              value={transaction?.matchedTruck?.targetPrice}
                            />
                            {' '}
                            {transaction?.matchedTruck?.priceType}
                            {' '}
                            {t('transaction:paymentTermsAre')}
                            {' '}
                            {transaction?.matchedTruck?.paymentTerm?.days}
                            {' '}
                            {t('transaction:days')}
                          </>
                        )
                        : (
                          <>    {t('transaction:noPreferredPrice')}
                          </>
                        )}
                    </div>
                    <div className="mt-20">
                      <div className="d-flex">
                        <InputLabeledContainer
                          name="bid"
                          className="mr-20"
                          labelClassName="form-label"
                          label={`${t('offer:enterYourOffer')} (${transaction?.matchedTruck?.priceType})`}
                          form={form}
                          errors={errors}
                          required
                          onChange={onChange}
                          renderInput={(rest) => (
                            <CurrencyInput
                              className="form-input w-auto"
                              currency="€"
                              placeholder={`${t('offer:yourPrice')} €`}
                              {...rest}
                            />
                          )}
                        />
                        {transaction.isNegotiable && (
                          <InputLabeledContainer
                            name="paymentTerm"
                            className="mr-20"
                            labelClassName="form-label"
                            label={`${t('offer:paymentTerms')} (${t('offer:optional')})`}
                            form={form}
                            errors={errors}
                            onChange={onChange}
                            renderInput={(rest) => (
                              <NumberInput
                                className="form-input w-auto"
                                placeholder={`${t('offer:paymentTerms')} ${t('offer:days')}`}
                                {...rest}
                              />
                            )}
                          />
                        )}
                      </div>
                      <GHref
                        onClick={reset}
                        className={'btn standard-btn mr-8 small bold confirm-step-btn-3 mt-16' + (step === 0 ? ' disabled' : '')}
                      >
                        {t('transaction:startOver')}
                      </GHref>
                      <GHref
                        onClick={!form.bid || step !== 2 ? null : sendBid}
                        submitting={submitting}
                        disabled={!form.bid || step !== 2 || submitting}
                        className="btn standard-btn small bold confirm-step-btn-3 mt-16"
                      >
                        {savingRoute
                          ? <>{t('transaction:savingRoute')}... </>
                          : <Trans i18nKey="offer:sendBid" />}
                      </GHref>
                    </div>
                  </div>
                </div>
                {step > 2 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>
            </div>
            {step > 2 && <OfferSentMessage type="truck" form={form} />}
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default withSendOffer(FirstOfferToTruck)
